/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return $; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return $$; });
var $ = document.querySelector.bind(document);
var $$ = document.querySelectorAll.bind(document);

Node.prototype.on = window.on = function (name, fn) {
  this.addEventListener(name, fn);
};

NodeList.prototype.__proto__ = Array.prototype;

NodeList.prototype.on = NodeList.prototype.addEventListener = function (name, fn) {
  this.forEach(function (elem, i) {
    elem.on(name, fn);
  });
};



/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bling__ = __webpack_require__(0);


var cssVars = window.getComputedStyle(document.documentElement);

var canvas = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bling__["a" /* $ */])('canvas');
var ctx = canvas.getContext('2d');
canvas.width = window.innerWidth + 1000;
canvas.height = window.innerHeight + 1000;
canvas.style.width = canvas.width + 'px';
canvas.style.height = canvas.height + 'px';
ctx.translate(0.5, 0.5);
ctx.strokeStyle = cssVars.getPropertyValue('--black');
ctx.lineJoin = 'round';
ctx.lineCap = 'round';
ctx.lineWidth = 5;
ctx.fillStyle = 'white';
ctx.fillRect(0, 0, canvas.width, canvas.height);

function pickColor() {
  var selectedColor = this.classList[1];
  if (selectedColor === 'erase') {
    ctx.strokeStyle = 'white';
    ctx.lineWidth = 20;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bling__["a" /* $ */])('.active').classList.add('erase');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bling__["a" /* $ */])('.active').style.backgroundColor = '';
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bling__["a" /* $ */])('.active .border').style.borderColor = cssVars.getPropertyValue('--gray');
  } else {
    ctx.lineWidth = 5;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bling__["a" /* $ */])('.active').classList.remove('erase');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bling__["a" /* $ */])('.active').style.backgroundColor = cssVars.getPropertyValue('--' + selectedColor);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bling__["a" /* $ */])('.active .border').style.borderColor = cssVars.getPropertyValue('--' + selectedColor);
    ctx.strokeStyle = cssVars.getPropertyValue('--' + selectedColor);
  }
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bling__["b" /* $$ */])('.color:not(.active)').forEach(function (color) {
  color.addEventListener('click', pickColor);
});

function toggleColorList() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bling__["a" /* $ */])('#colors').classList.toggle('open');
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bling__["a" /* $ */])('.color.active').addEventListener('click', toggleColorList);

var isDrawing = false;
var lastX = 0;
var lastY = 0;

function draw(e) {
  if (!isDrawing) return;
  ctx.beginPath();
  ctx.moveTo(lastX + '.5', lastY + '.5');
  ctx.lineTo(e.offsetX, e.offsetY);
  ctx.stroke();
  var _ref = [e.offsetX, e.offsetY];
  lastX = _ref[0];
  lastY = _ref[1];
}

function downloadSVG() {
  var data = canvas.toDataURL('image/jpeg');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bling__["a" /* $ */])('#download').href = data;
}

canvas.addEventListener('mousedown', function (e) {
  isDrawing = true;
  var _ref2 = [e.offsetX, e.offsetY];
  lastX = _ref2[0];
  lastY = _ref2[1];

  console.log(ctx.strokeStyle);
});

canvas.addEventListener('mousemove', draw);
canvas.addEventListener('mouseup', function () {
  isDrawing = false;downloadSVG();
});
canvas.addEventListener('mouseout', function () {
  isDrawing = false;downloadSVG();
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// source/assets/js/bundle.js